import { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/payroll-types';

export const getPayrollTypeDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
